import { createContext, useContext } from 'react';
import { CONFIG } from '@frontend/config';

export const HotelAgencyContext = createContext(Number(CONFIG.AGENCY_ID));
export const useHotelAgency = () => useContext(HotelAgencyContext);
